import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class TutorialModalService {
    private readonly openTutorialRequests$ = new Subject<void>();

    requestOpenTutorialModal(): void {
        this.openTutorialRequests$.next();
    }

    watchOpenTutorialRequests(): Observable<void> {
        return this.openTutorialRequests$.asObservable();
    }
}
